import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useSaveLeadArConfig = (options) => {
  const res = useMutation(
    (dto) =>
      http.post(HTTP_ENDPOINTS.leadArIntegration.saveLeadArConfig(), {
        is_enabled: dto.isEnabled,
        location_id: dto.locationId,
      }),
    {
      ...options,
    },
  );

  return res;
};
